// extracted by mini-css-extract-plugin
export default {"layout":"_2v5wRbFVgPqxavMa2HG51N"};